import LegalInformationTable from "./legal-information-table";

export default LegalInformationTable;
